import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// API call for produc-add-edit
export const addUpdateProduct = createAsyncThunk("product/addupdate", async (reqbody) => {

    console.log("reqbody==>", reqbody);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/addeditproduct", requestOptions);
    const respdata = await response.json();
    console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});






// API call for produc-list
export const getproductList = createAsyncThunk("product/list", async (reqbody) => {

    // console.log("reqbody==>", reqbody);

    let req_body = {};
    req_body= {...reqbody};
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/listproduct", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});

// API call for getproductList_Count
export const getproductList_Count = createAsyncThunk("product/list_count", async (reqbody) => {

    // console.log("reqbody==>", reqbody);

    let req_body = {};
    req_body= {...reqbody};
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/productlist_count", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});

// API call for CartProducts
export const getCartProductList = createAsyncThunk("CartProduct/list", async (reqbody) => {

    // console.log("reqbody==>", reqbody);
    let req_body = {};
    req_body= {...reqbody};
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api/addorremovecartproduct", requestOptions);
    const respdata = await response.json();
    console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
})

// API call for getcartitems
export const getCartItems = createAsyncThunk("getcartitems/list", async (reqbody) => {

    // console.log("reqbody==>", reqbody);
    // let req_body = {};
    // req_body= {...reqbody};
    // console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api/getcartitems", requestOptions);
    const respdata = await response.json();
    console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
})

////////////////////////////////// Delete multiple product form Table //////////////////////////////////

export const deletemultyple = createAsyncThunk("product/list/delete", async(reqbody) => {

    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/deleteproductmany", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});

////////////////////////////////// Edit Multiple Item form Table //////////////////////////////////
export const editmultyple = createAsyncThunk("product/list/edit", async(reqbody) => {

    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/producteditmultiple", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});


const productManagment = createSlice({
    name: 'productManagment',
    initialState: {
        submitting: false,
        product: {},
        submitted: false,
        message: null,
        loading: false,
        success: false,
        successmsg: "",
        productList: [],
        productList_Count: null,
        cartData: []
    },
    reducers: {

        setSuccessAfterSubmit(state, action) {
            state.success = false;
        },

        // setAddToCart(state, action) {
        //     state.cartData = [...state.cartData, action.payload.productData];
        // },
    },

    extraReducers: {
        /// For GEt Product List
        [getproductList.rejected]: (state, action) => {
            state.loading = false;
        },
        [getproductList.pending]: (state, action) => {
            // console.log("action p", action)
            // state.productList = [];
            state.loading = true;
        },
        [getproductList.fulfilled]: (state, action) => {
            console.log("action f", action)
            if (action.payload.status === 'success') {
                state.productList = [...state.productList,...action.payload.results.res];
                state.message = action.payload.status;
                // state.submitted = true;
                state.loading = false;

            }
        },

        /// For Get Product List Count
        [getproductList_Count.fulfilled]: (state, action) => {
            if (action.payload.status === 'success') {
                state.productList_Count = action.payload.count;
                state.loading = false;
            }
        },



        //////////////////////////// Delete Multiple User ///////////////////////////////
        [deletemultyple.pending]: (state, action) => {

            state.loading = true;
        },
        [deletemultyple.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Deleted Successfully';
                state.success = true;
            }

        },
        [deletemultyple.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },

        //////////////////////////// Edit Multiple Item ///////////////////////////////
        [editmultyple.pending]: (state, action) => {
            state.loading = true;
        },
        [editmultyple.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully';
                state.success = true;
            }
        },
        [editmultyple.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },

        //////////////////////////// update product access///////////////////////////////
        [addUpdateProduct.pending]: (state, action) => {
            state.loading = true;
        },
        [addUpdateProduct.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully';
                state.success = true;
            }
        },
        [addUpdateProduct.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },

        //////////////////////////// Add Product on sucess ///////////////////////////////       
        [getCartProductList.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                // state.cartData = [...state.cartData, state.productList.find((current) => current._id == action.payload.results.res.product_id )];
                state.successmsg = 'Product Added Successfully';
                state.success = true;
            }
        },
        [getCartItems.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.cartData = action.payload.results.res;
                state.successmsg = 'Cart Item Added Successfully';
                state.success = true;
            }
        },
        


    }

})

export default productManagment.reducer;
export const { setSuccessAfterSubmit, setAddToCart } = productManagment.actions;

